import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ChatUserAttributes,
  ChatUserUpdateRequestDPI,
} from '../types/interfaces/chat-user';

@Injectable({
  providedIn: 'root',
})
export class ChatUserService {
  private http = inject(HttpClient);


  getChatUsers(filter?: string) {
    const params = new URLSearchParams();
    params.append('channels', 'whatsapp');

    if (filter) {
      params.append('filter', filter);
    }

    return this.http.get<ChatUserAttributes[]>(
      `${environment.apiHost}/chat-users?${params.toString()}`,
      {
        withCredentials: true,
      },
    );
  }

  updateChatUser(data: {
    ticketId: number;
    userId: number;
    name?: string;
    dpi?: string;
    notes?: string;
  }) {
    return this.http.put(`${environment.apiHost}/chat-users`, data, {
      withCredentials: true,
    });
  }
}
